export default __webpack_public_path__ + "static/anastasiaFrame-1290c5a2551778e3ac3555603eccc7f4.webp";